import { combineReducers } from "redux";
import { createSlice } from "@reduxjs/toolkit";

import { sentences } from "../slices/sentences";
import { characters } from "../slices/characters";
import { logos } from "../slices/logos";

const counter = createSlice({
  name: "counter",
  initialState: 0,
  reducers: {
    increment: (state) => state + 1,
    decrement: (state) => state - 1,
    incrementByAmount: (state, action) => {
      state += action.payload;
      return state;
    },
  },
});

export default combineReducers({
  //counter: counter.reducer,
  sentences: sentences.reducer,
  characters: characters.reducer,
  logos: logos.reducer,
});
